import { PBox } from "../../theme/BaseTheme";
import { FeatureImageLeft } from "../../sections/FeatureImageLeft";
import { FeatureImageRight } from "../../sections/FeatureImageRight";
import { SellFaq } from "../../sections/SellFaq";
import UseCases from "../../sections/UseCases";

const manga_filter_faq_data = [
    {
        question: "What is the Manga Filter, and how does it work?",
        answer: "The Manga Filter is an AI-powered tool that transforms your photos into authentic Japanese manga-style artwork. It uses comic-style shading, ink outlines, and halftone textures to give your image the look of a hand-drawn manga panel.",
    },
    {
        question: "Do I need any artistic skills to use the Manga Filter?",
        answer: "No, you don’t! The Manga Filter automatically detects faces, lighting, and shadows to generate stylized black-and-white or ink-toned images — just like real manga art — with a single click.",
    },
    {
        question: "What kinds of photos work best with the Manga Filter?",
        answer: "Portraits and expressive photos work best, but you can use the filter on anything — from pets to landscapes — for a bold, illustrated effect. Dynamic lighting and emotion in the photo enhance the manga-style results.",
    },
    {
        question: "Are my uploaded photos safe and private?",
        answer: "Yes, absolutely. Patternful.ai deletes all uploaded photos several hours later after processing. Your generated manga artwork is private and remains fully yours.",
    },
];

const manga_filter_use_cases = [
    {
        title: "Manga-Style Portraits",
        description:
            "Transform yourself into a manga character! Perfect for profile pictures, creative portfolios, or sharing unique black-and-white portraits that look like they came straight from a comic series.",
        image: "/images/image-filters/manga-filter-5.webp",
    },
    {
        title: "Comics & Storytelling",
        description:
            "Create your own manga scenes by converting different images into cohesive black-and-white comic panels. Perfect for writers, artists, and digital storytellers.",
        image: "/images/image-filters/manga-filter-6.webp",
    },
    {
        title: "Artistic Posters & Prints",
        description:
            "Design stylish manga art for posters, merchandise, or wall decor. Ideal for anime and manga fans who love graphic, dramatic visual styles.",

        image: "/images/image-filters/manga-filter-7.webp",
    },
];

const MangaFilter = () => {
    return (
        <PBox>
            <FeatureImageLeft
                image={"/images/image-filters/manga-filter-1.webp"}
                title={"Turn Photos into Authentic Manga Art"}
                description={
                    "Bring your photos to life in bold Manga style! The Manga Filter applies traditional manga techniques — clean outlines, halftone shading, and expressive lighting — to instantly transform any image into a page-worthy illustration."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/manga-filter-2.webp"}
                title={"Create Manga Characters from Selfies"}
                description={
                    "Ever wanted to see yourself as a manga hero or heroine? The AI stylizes your facial features into detailed ink art, complete with sharp shadows and stylized hair — all while preserving your unique look."
                }
            />
            <FeatureImageLeft
                image={"/images/image-filters/manga-filter-3.webp"}
                title={"Make Dramatic Story Panels and Expressions"}
                description={
                    "Use expressive selfies or action shots to create dramatic panels. The Manga Filter automatically enhances emotion, contrast, and line detail to match the storytelling intensity found in manga scenes."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/manga-filter-4.webp"}
                title={"Stylize Pets, Objects, or Backgrounds in Manga Tone"}
                description={
                    "The Manga Filter isn't limited to faces — use it on pets, architecture, or scenery to create detailed backgrounds and artistic manga settings. Great for stylized collages or storytelling layouts."
                }
            />
            <UseCases
                data={manga_filter_use_cases}
                title={"Creative and Pretty Manga Filters for Everyone"}
            />
            <SellFaq data={manga_filter_faq_data} />
        </PBox>
    );
};

export default MangaFilter;
